const paragraphNumbered = [
  "M5 0H2.36C1.55 0 .87.68.87 1.5c0 .83.68 1.5 1.5 1.5v1.87c0 .23.15.38.37.38.23 0 .38-.19.38-.38V.75h.75v4.12c0 .23.15.38.37.38.23 0 .38-.19.38-.38V.75h.37c.2 0 .38-.15.38-.37 0-.23-.15-.38-.38-.38z",
  "M6.16 15.27l.93-3.48h2.36l-.93 3.48h1.77l.93-3.48h3.25l.46-1.7h-3.26l.62-2.28h3.24L16 6.1h-3.26l.88-3.22h-1.77l-.87 3.22H8.6l.88-3.22H7.71L6.85 6.1H3.59l-.47 1.7h3.26l-.6 2.28H2.52l-.45 1.7h3.26l-.95 3.49zm3.75-5.19H7.55l.6-2.27h2.37z"
];
export {
  paragraphNumbered
};
//# sourceMappingURL=paragraphNumbered.js.map
